<template>
  <div id="detail" class="oa-page">
    <div style="text-align: center;">
      <img
        src="@/assets/serviceImg/service/Frame_4108@2x(1).png"
        alt="门诊协助"
        class="oa-banner-img"
      />
    </div>

    <section class="oa-section">
      <div class="oa-section-title">服务介绍</div>
      <div class="oa-section-content">{{ pageCopy.intro }}</div>
    </section>

    <section class="oa-section">
      <div class="oa-section-title">核心服务</div>
      <ul class="oa-service-list">
        <li v-for="item in pageCopy.coreServices" :key="item">{{ item }}</li>
      </ul>
    </section>

    <section class="oa-section">
      <div class="oa-section-title">所需材料</div>
      <div class="oa-section-content">{{ pageCopy.materials }}</div>
    </section>

    <section class="oa-section">
      <div class="oa-section-title">使用规则</div>
      <ul class="oa-rule-list">
        <li v-for="item in pageCopy.rules" :key="item">{{ item }}</li>
      </ul>
    </section>

    <section class="oa-section">
      <div class="oa-section-title">使用方式</div>
      <div class="oa-section-content">
        {{ pageCopy.usageBefore }}
        <a :href="hotlineTel" class="oa-hotline-link">{{ hotlineDisplay }}</a>
        {{ pageCopy.usageAfter }}
      </div>
    </section>

    <div class="oa-action-bar">
      <button
        type="button"
        class="oa-action-btn"
        :class="{ 'oa-action-btn--disabled': !equityCanUse }"
        :disabled="!equityCanUse"
        @click="actionGetService"
      >{{ getServiceBtnText }}</button>
    </div>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <p class="modal-tip">该项权益需开通以下服务权益</p>
        <div class="modal-card" @click="equity">
          <img class="modal-card-bg" src="@/assets/img/qykbj.png" alt="" />
          <h3 class="modal-card-title">大救星-星健康权益卡</h3>
          <div class="modal-card-desc">多项健康权益尊享，为您健康守护</div>
          <div class="modal-card-btn">了解更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaiheServiceCopy } from '@/utils/taiheServiceCopy'
import equityUsedCountMixin from '@/mixins/equityUsedCountMixin'

/** 24 小时救援热线 */
const RESCUE_HOTLINE_DISPLAY = '+86-10-89180868'
const RESCUE_HOTLINE_TEL = 'tel:+861089180868'

/** 门诊协助统一展示文案 */
const OUTPATIENT_ASSIST_COPY = Object.freeze({
  intro:
    '针对心血管疾病就医用户，结合既往诊断精准分诊，匹配适配公立医院科室专家，协助完成门诊挂号。',
  coreServices: [
    '推荐适配医院/专科专家（可指定科室，不可指定医生）',
    '诊前提醒',
    '就诊当日远程协助就医'
  ],
  materials: '实名身份信息、心血管疾病既往诊断病历资料',
  rules: [
    '使用前提：下载【大救星健康版】APP，实名注册开通服务，门诊相关费用自理；',
    '服务范围：北上广深、成都、杭州、苏州等全国公立二级及以上医院；',
    '服务时效：确认就诊方案后5个工作日内安排就诊，48小时同步服务进度；',
    '使用次数：合同有效期内仅限本人使用1次，不可转让；',
    '备注：服务安排成功后用户主动取消，视同权益已消耗。'
  ],
  usageBefore: '登录【大救星健康版】APP一键救援，或拨打24小时热线 ',
  usageAfter: '提交需求；专员核验资料调度排号，诊前提醒，就诊当日远程协助就医。'
})

export default {
  equityServiceKey: 'outpatientAssist',
  mixins: [equityUsedCountMixin],
  data() {
    return {
      showModal: false,
      equityinfoType: false,
      hotlineDisplay: RESCUE_HOTLINE_DISPLAY,
      hotlineTel: RESCUE_HOTLINE_TEL
    }
  },
  computed: {
    /**
     * 根据 productId 返回门诊协助页面文案（保留 id 判断，当前各 id 统一展示同一套文案）
     * @returns {{ intro: string, coreServices: string[], materials: string, rules: string[], usageBefore: string, usageAfter: string }}
     */
    pageCopy() {
      const productId = this.$route.query.productId
      if (productId === '949' || productId === 949) {
        return OUTPATIENT_ASSIST_COPY
      }
      if (productId === '947' || productId === 947) {
        return OUTPATIENT_ASSIST_COPY
      }
      getTaiheServiceCopy(productId, 'outpatientAssist', OUTPATIENT_ASSIST_COPY.intro)
      return OUTPATIENT_ASSIST_COPY
    }
  },
  created() {
    document.title = '门诊协助'
    this.equityinfoType = localStorage.getItem('equityinfo')
  },
  beforeCreate() {
    document.querySelector('#app').setAttribute('style', 'background-color:#F2F3F5')
  },
  mounted() {
    if (localStorage.getItem('oldAge') == 1) {
      document.getElementById('html').style.fontSize = '48px'
    }
  },
  methods: {
    /**
     * 获取服务：与其它二级页一致，进入一键救援并传递 caseType（不再进入预约挂号页）
     */
    actionGetService() {
      if (typeof this.goRescueWithCaseType === 'function') {
        this.goRescueWithCaseType()
        return
      }
      // 兜底：mixin 异常时仍进一键救援，避免误入预约挂号页
      const caseType = this.currentCaseType || '941'
      const query = { caseType, from: 'service' }
      const productId = this.resolvedProductId || this.$route.query.productId
      if (productId != null && productId !== '') {
        query.productId = productId
      }
      this.$router.push({ name: 'onClickRescue', query })
    },
    /**
     * 跳转权益卡介绍
     */
    equity() {
      this.$router.push({
        path: '/equity',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="less">
.oa-page {
  min-height: 100vh;
  padding: 1rem 0.5rem calc(76px + env(safe-area-inset-bottom));
  background: #f2f3f5;
  box-sizing: border-box;
}

.oa-banner-img {
  width: 100px;
  height: 100px;
  vertical-align: middle;
  margin-right: 0.5vw;
  margin-bottom: 1rem;
}

.oa-section {
  margin-bottom: 12px;
  padding: 16px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.oa-section-title {
  position: relative;
  padding-left: 10px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  line-height: 1.3;
}

.oa-section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 3px;
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #00c275 0%, #4ecdc4 100%);
}

.oa-section-content {
  font-size: 14px;
  color: #666666;
  line-height: 1.75;
  text-align: justify;
}

.oa-hotline-link {
  color: #00bb82;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.oa-hotline-link:active {
  opacity: 0.75;
}

.oa-service-list,
.oa-rule-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.oa-service-list li,
.oa-rule-list li {
  position: relative;
  padding-left: 14px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #666666;
  line-height: 1.65;
}

.oa-service-list li::before,
.oa-rule-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00c275;
}

.oa-service-list li:last-child,
.oa-rule-list li:last-child {
  margin-bottom: 0;
}

.oa-action-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: rgba(242, 243, 245, 0.96);
  backdrop-filter: blur(8px);
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.oa-action-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: rgb(0, 187, 130);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.oa-action-btn:active {
  opacity: 0.9;
  transform: scale(0.99);
}

.oa-action-btn--disabled,
.oa-action-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.modal {
  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  padding: 8% 5%;
  border-radius: 12px 12px 0 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
}

.modal-tip {
  margin: 0 0 20px;
  font-size: 15px;
  color: #333333;
  text-align: center;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
}

.close:hover,
.close:focus {
  color: #000000;
  cursor: pointer;
}

.modal-card {
  position: relative;
  height: 160px;
  overflow: hidden;
  border-radius: 12px;
}

.modal-card-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-card-title {
  position: absolute;
  top: 56px;
  left: 24px;
  margin: 0;
  font-size: 18px;
  color: #333333;
}

.modal-card-desc {
  position: absolute;
  top: 88px;
  left: 24px;
  font-size: 13px;
  color: #666666;
}

.modal-card-btn {
  position: absolute;
  top: 56px;
  right: 16px;
  width: 72px;
  height: 28px;
  border-radius: 16px;
  background: rgb(74, 71, 64);
  color: #f2d57a;
  font-size: 12px;
  line-height: 28px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/detailsH5/outpatientAssist.vue